import globalData from '@/lib/globals';

// Apply global estate groups filter (gruppennummer IN ...), if configured
export function applyGlobalEstateFilters< T extends { in: Function } >(
	query: T
) {
	const groups: string[] =
		( globalData as any )?.kam001_real_estate_blocks_globals?.config
			?.filterEstateGroups ??
		( globalData as any )?.config?.filterEstateGroups ??
		[];

	if ( Array.isArray( groups ) && groups.length > 0 ) {
		return ( query as any ).in( 'gruppennummer', groups );
	}

	return query;
}
